import { render, staticRenderFns } from "./FeaturedCollection.vue?vue&type=template&id=625de5f4"
import script from "./FeaturedCollection.vue?vue&type=script&lang=js"
export * from "./FeaturedCollection.vue?vue&type=script&lang=js"
import style0 from "./FeaturedCollection.vue?vue&type=style&index=0&id=625de5f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports